import { DAYS_FOR_NOTIFICATION } from "@/constants";
import { getDaysRemaining } from "@/utils/date";

import { ReMintVariant } from "./interface";

export const calculateLimitScoreForUpdate = (currentScore: number): number => {
  return currentScore * 0.15;
};

export const getReMintVariant = (currentScore: number, newScore: number, expirationDate: number | null) => {
  const dateNow = Date.now();
  const badScore = currentScore - newScore >= calculateLimitScoreForUpdate(currentScore);

  if (expirationDate) {
    if (dateNow > expirationDate)
      return badScore ? ReMintVariant.ReMintWithExpiredAndUpdate : ReMintVariant.ReMintWithExpired;

    const daysRemaining = getDaysRemaining(expirationDate);

    if (daysRemaining < DAYS_FOR_NOTIFICATION)
      return badScore ? ReMintVariant.ReMintWithUpcomingExpiryAndUpdated : ReMintVariant.ReMintWithUpcomingExpiry;
  }

  if (newScore > currentScore) return ReMintVariant.BaseReMint;
  return null;
};
